export default __webpack_public_path__ + "static/media/imusd-mta.a868fd91.svg";